import { Component, computed, inject } from '@angular/core';
import { AuthService } from 'core/services/auth.service';
import { EmptyComponent } from './empty/empty.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { KorviuLoaderComponent } from 'shared/components/korviu-loader/korviu-loader.component';

/**
 * V2 of the My Forest
 * */
@Component({
  selector: 'app-my-forest',
  imports: [EmptyComponent, DashboardComponent, KorviuLoaderComponent],
  templateUrl: './my-forest.component.html',
  styleUrl: './my-forest.component.scss'
})
export class MyForestComponent {
  readonly authService = inject(AuthService);

  readonly currentUser = computed(() => this.authService.currentUser$());
  readonly ganarbolsNumber = computed<number>(() => this.currentUser()?.totalGanarbols ?? 0);
  readonly ganacuatesNumber = computed<number>(() => this.currentUser()?.totalGanacuates ?? 0);
  readonly community = computed<number>(() => this.currentUser()?.totalNetworkSize ?? 0);

  readonly showEmptyPage = computed<boolean>(() => !!this.currentUser() && this.community() === 0);
}
